import { ProductBlock } from "./product-block";

export class MediaBlock extends ProductBlock {
    public static CLASS_NAME = "media-block";
    
    private video: JQuery;

    constructor(e: HTMLElement) {
        super(e);
        this.video = $(".video", this.element);
    }

    public initiate() {
        super.initiate();
        $("body").trigger("click");
    }
    
    protected onScroll() {
        super.onScroll();

        if (this.isInView) {
            
        }
    }
    
    protected inView() {
        super.inView();
    }

    protected outOfView() {
        super.outOfView();
    }

    protected activate() {
        if (!this.isActivated && this.video.length > 0) {
            (this.video[0] as any).play();
        }
        super.activate();
    }
}

Audio.prototype.play = (function (play) {
    return function () {
        var audio = this,
            args = arguments,
            promise = play.apply(audio, args);
        if (promise !== undefined) {
            promise.catch(_ => {
                // Autoplay was prevented. This is optional, but add a button to start playing.
                var el = document.createElement("button");
                el.innerHTML = "Play";
                el.addEventListener("click", function () { play.apply(audio, args); });
                this.parentNode.insertBefore(el, this.nextSibling)
            });
        }
    };
})(Audio.prototype.play);